import _ from '@lodash';

const ProgramModel = (data) =>
  _.defaults(data || {}, {
    name: '',
    description: '',
    type: '',
    website: '',
    email: '',
    clientTypes: [],
    specializations: [],
    treatments: [],
    acceptedInsurance: [],
    acceptingClients: false,
    acceptsInsurance: false,
    providesTelehealth: false,
  });

export default ProgramModel;
